<template>
    <h1>Please Select Another Chart</h1>
</template>
